// all notes
export const ALL_NOTES_REQUEST = "ALL_NOTES_REQUEST";
export const ALL_NOTES_SUCCESS = "ALL_NOTES_SUCCESS";
export const ALL_NOTES_FAIL = "ALL_NOTES_FAIL";
export const ALL_NOTES_PUSH = "ALL_NOTES_PUSH";

// single notes
export const SINGLE_NOTES_REQUEST = "SINGLE_NOTES_REQUEST";
export const SINGLE_NOTES_SUCCESS = "SINGLE_NOTES_SUCCESS";
export const SINGLE_NOTES_FAIL = "SINGLE_NOTES_FAIL";

// Add new Point
export const ADD_NEW_POINT_REQUEST = "ADD_NEW_POINT_REQUEST";
export const ADD_NEW_POINT_SUCCESS = "ADD_NEW_POINT_SUCCESS";
export const ADD_NEW_POINT_FAIL = "ADD_NEW_POINT_FAIL";

// Add user to the notes
export const ADD_USER_TO_NOTES_REQUEST = "ADD_USER_TO_NOTES_REUREST";
export const ADD_USER_TO_NOTES_SUCCESS = "ADD_USER_TO_NOTES_SUCCESS";
export const ADD_USER_TO_NOTES_FAIL = "ADD_USER_TO_NOTES_FAIL";

export const CLEAR_NOTES_ERRORS = "CLEAR_NOTES_ERRORS";
